<template>
  <div class="top-header">
    <v-container pa-0>
      <v-row>
        <v-col
          cols="8"
          class="header__title">
          <a
            :href="`https://www.lausanne-tourisme.ch/${locale}/business/`"
            class="top-header__title"
          >
            {{ $t('header.title') }}
          </a>
        </v-col>
        <v-col
          cols="2"
          v-for="(button, index) in buttons"
          :key="index"
        >
          <HeaderButton
            :link="button.link"
            :text="button.text"
            :icon="button.icon"
          >
          </HeaderButton>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import HeaderButton from './HeaderButton.vue'

  import { mdiMapMarkerOutline, mdiEmailOutline } from '@mdi/js'

  export default {
    name: 'TheTopHeader',

    components: {
      HeaderButton,
    },

    computed: {
      locale() {
        return this.$store.state.locale
      },

      buttons() {
        return [
          {
            text: this.$t('buttons.event'),
            link: { name: 'HomePage', params: { locale: this.locale } },
            icon: mdiMapMarkerOutline,
          },
          {
            text: this.$t('buttons.advice'),
            link: { name: 'AdvicePage', params: { locale: this.locale } },
            icon: mdiEmailOutline,
          },
        ]
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"

  .top-header
    height: 60px
    background-color: $primary-color

    &__title
      font-size: 22px
      color: #FFF
      text-decoration: none

  @media (max-width: 960px)
    .v-application .pa-0
      padding: 0 15px !important

    .top-header

      &__title
        text-align: center
</style>
